// DO NOT IMPORT i18n FROM THE MODULE'S INDEX AS THIS CAUSES CIRCULAR DEPENDENCIES
import { createI18n } from 'vue-i18n';
import answerSearchi18n from '@/modules/answer-search/i18n';
import components from '@@/packages/shared/components/i18n/en';
import authi18n from '@/modules/auth/i18n';
import approvali18n from '@/modules/approval/i18n';
import assessment from '@/modules/assessment/i18n/en';
import profile from '@/modules/profile/i18n/en';
import actionCentre from '@/modules/action-centre/i18n';
import labels from '@/modules/labels/i18n/en';
import searchi18n from '@/modules/search/i18n';
import mode from '@/modules/mode/i18n/en';
import invite from '@/modules/invite/i18n/en';
import policy from '@/modules/policy/i18n/en';
import global from '@/i18n/global/en';
import activityFeedi18n from '@/modules/activity-feed/i18n';
import answeri18n from '@/modules/answer/i18n';
import discussionsi18n from '@/modules/discussions/i18n/en';
import discussionsInActivityFeedi18n from '@/modules/discussions-in-activity-feed/i18n';
import orgInfoi18n from '@/modules/org-info/i18n';
import logini18n from '@/modules/login/i18n';
import authSSOLogini18n from '@/modules/auth-ssologin/i18n';
import authSSOSettingsi18n from '@/modules/auth-ssosettings/i18n';
import clientNotesi18n from '@/modules/client-notes/i18n';
import clientDocumentsi18n from '@/modules/client-documents/i18n';
import notificationSettingsi18n from '@/modules/notification-settings/i18n';
import clientReportingi18n from '@/modules/client-reporting/i18n';
import clientNetworki18n from '@/modules/client-network/i18n';
import settingsi18n from '@/modules/settings/i18n';
import connectionRequesti18n from '@/modules/connection-request/i18n';
import welcomei18n from '@/modules/welcome/i18n';
import profileSharingLinksi18n from '@/modules/profile-sharing-links/i18n';
import profileSharingPublici18n from '@/modules/profile-sharing-public/i18n';
import businessApprovalPublici18n from '@/modules/business-approval-public/i18n';
import clientDashboardi18n from '@/modules/client-dashboard/i18n';
import connectionViewSuppliersi18n from '@/modules/connection-view-suppliers/i18n';
import connectionViewClientsi18n from '@/modules/connection-view-clients/i18n';
import filtersi18n from '@/modules/filters/i18n';
import uploadsi18n from '@/modules/uploads/i18n';
import filePreviewi18n from '@/modules/file-preview/i18n';
import apiPublici18n from '@/modules/api-public/i18n';
import emergingThreatsSuppliersi18n from '@/modules/emerging-threats-suppliers/i18n';
import emergingThreatsCommoni18n from '@/modules/emerging-threats-common/i18n';
import emergingThreatsClientsi18n from '@/modules/emerging-threats-clients/i18n';
import customPropertiesi18n from '@/modules/custom-properties/i18n';
import triali18n from '@/modules/trial/i18n';
import risksi18n from '@/modules/risks/i18n';
import routes from '@/routes/i18n';
import salesMockNetworkGraphi18n from '@/modules/sales-mock-network-graph/i18n';
import federatedDashboardi18n from '@/modules/federated-dashboard/i18n';
import controlTypei18n from '@/modules/control-type/i18n';
import connectionViewSubEntitiesi18n from '@/modules/connection-view-sub-entities/i18n';
import federatedNetworki18n from '@/modules/federated-network/i18n';
import federatedSubEntitiesProfilei18n from '@/modules/federated-sub-entities-profile/i18n';
import federatedSuppliersi18n from '@/modules/federated-suppliers/i18n';
import documentsi18n from '@/modules/documents/i18n';
import messages from '@/legacy/i18n/messages';
import insightsi18n from '@/modules/insights/i18n';
import reportingi18n from '@/modules/reporting/i18n';
import rolesi18n from '@/modules/roles/i18n';
import errorsi18n from '@/modules/errors/i18n';
import { zeusMessages } from '@/zeusIntegration';
import communitiesi18n from '@/modules/communities/i18n';
import communitiesMessageBoardi18n from '@/modules/communities-message-board/i18n';
import externalMonitoringi18n from '@/modules/external-monitoring/i18n';
import productsi18n from '@/modules/products/i18n';
import growth from '@/modules/growth/i18n';
import plgClientOnboardingChecklist from '@/modules/plg-client-onboarding-checklist/i18n';
import securityProfile from '@/modules/security-profile/i18n';
import securityProfileSettings from '@/modules/security-profile-settings/i18n';
import quickAnswer from '@/modules/quick-answer/i18n';
import connectionReviewi18n from '@/modules/connection-reviews/i18n';
import reviewSharingi18n from '@/modules/review-sharing/i18n';
import publicDatai18n from '@/modules/public-data/i18n';
import offlineAssessmenti18n from '@/modules/offline-assessment/i18n';

export const translations = {
  en: {
    ...messages.en,
    ...zeusMessages,
    global: global.en,
    components: components.en,
    auth: authi18n.en,
    approval: approvali18n.en,
    assessment: assessment.en,
    clientDashboard: clientDashboardi18n.en,
    profile: profile.en,
    actionCentre: actionCentre.en,
    labelsModule: labels.en,
    search: searchi18n.en,
    connectionRequest: connectionRequesti18n.en,
    invite: invite.en,
    mode: mode.en,
    policy: policy.en,
    activityFeed: activityFeedi18n.en,
    answer: answeri18n.en,
    discussions: discussionsi18n.en,
    discussionsInActivityFeed: discussionsInActivityFeedi18n.en,
    orgInfo: orgInfoi18n.en,
    routes: routes.en,
    login: logini18n.en,
    authSSOLogin: authSSOLogini18n.en,
    authSSOSettings: authSSOSettingsi18n.en,
    clientNotes: clientNotesi18n.en,
    clientDocuments: clientDocumentsi18n.en,
    notificationSettings: notificationSettingsi18n.en,
    clientReporting: clientReportingi18n.en,
    clientNetwork: clientNetworki18n.en,
    settings: settingsi18n.en,
    welcome: welcomei18n.en,
    profileSharingLinks: profileSharingLinksi18n.en,
    profileSharingPublic: profileSharingPublici18n.en,
    businessApprovalPublic: businessApprovalPublici18n.en,
    controlType: controlTypei18n.en,
    connectionViewSuppliers: connectionViewSuppliersi18n.en,
    connectionViewClients: connectionViewClientsi18n.en,
    filters: filtersi18n.en,
    uploads: uploadsi18n.en,
    filePreview: filePreviewi18n.en,
    apiPublic: apiPublici18n.en,
    emergingThreatsSuppliers: emergingThreatsSuppliersi18n.en,
    emergingThreatsClients: emergingThreatsClientsi18n.en,
    emergingThreatsCommon: emergingThreatsCommoni18n.en,
    customProperties: customPropertiesi18n.en,
    trial: triali18n.en,
    risks: risksi18n.en,
    salesMockNetworkGraph: salesMockNetworkGraphi18n.en,
    connectionViewSubEntities: connectionViewSubEntitiesi18n.en,
    federatedDashboard: federatedDashboardi18n.en,
    federatedNetwork: federatedNetworki18n.en,
    federatedSubEntitiesProfile: federatedSubEntitiesProfilei18n.en,
    federatedSuppliers: federatedSuppliersi18n.en,
    documents: documentsi18n.en,
    insights: insightsi18n.en,
    reporting: reportingi18n.en,
    roles: rolesi18n.en,
    errorScreens: errorsi18n.en,
    communities: communitiesi18n.en,
    communitiesMessageBoard: communitiesMessageBoardi18n.en,
    externalMonitoring: externalMonitoringi18n.en,
    answerSearch: answerSearchi18n.en,
    products: productsi18n.en,
    growth: growth.en,
    plgClientOnboardingChecklist: plgClientOnboardingChecklist.en,
    securityProfile: securityProfile.en,
    securityProfileSettings: securityProfileSettings.en,
    quickAnswer: quickAnswer.en,
    connectionReview: connectionReviewi18n.en,
    reviewSharing: reviewSharingi18n.en,
    publicData: publicDatai18n.en,
    offlineAssessment: offlineAssessmenti18n.en,
  },
};

export type Translations = typeof translations;

export const i18n = createI18n<{ messages: Translations['en'] }, 'en'>({
  locale: 'en',
  warnHtmlInMessage: 'off',
  messages: translations,
  missing(_locale, key) {
    logError(`Translation missing for "${key}"`);
    return key;
  },
});
